import { useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { Nav } from "@/components/sections/Nav";
import { Hero } from "@/components/sections/Hero";
import { Marquee } from "@/components/sections/Marquee";
import { Countdown } from "@/components/sections/Countdown";
import { GlobalInspiration } from "@/components/sections/GlobalInspiration";
import { OurVision } from "@/components/sections/OurVision";
import { EvolutionTimeline } from "@/components/sections/EvolutionTimeline";
import { Benefits } from "@/components/sections/Benefits";
import { OurPromise } from "@/components/sections/OurPromise";
import { Sponsors } from "@/components/sections/Sponsors";
import { KidsGames } from "@/components/sections/KidsGames";
import { ShareCardSection } from "@/components/sections/ShareCardSection";
import { Registration } from "@/components/sections/Registration";
import { FutureVision } from "@/components/sections/FutureVision";
import { FloatingWhatsApp } from "@/components/sections/FloatingWhatsApp";

const readCount = () => {
  try {
    const list = JSON.parse(window.localStorage.getItem("sc_regs") || "[]");
    return 100 + list.length;
  } catch {
    return 100;
  }
};

function App() {
  const [count, setCount] = useState(readCount);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="App">
        <Nav />
        <main>
          <Hero count={count} />
          <Marquee />
          <Countdown />
          <GlobalInspiration />
          <OurVision />
          <EvolutionTimeline />
          <Benefits />
          <OurPromise />
          <Sponsors />
          <KidsGames />
          <ShareCardSection />
          <Registration onRegistered={(n) => setCount(100 + n)} />
          <FutureVision />
        </main>
        <FloatingWhatsApp />
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              background: "#111625",
              border: "1px solid rgba(253,230,138,0.25)",
              color: "#fff",
            },
          }}
        />
      </div>
    </LanguageProvider>
  );
}

export default App;
